/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function compressImage(params, context) {
    var _a;
    // 钉钉h5微应用 ref: https://open.dingtalk.com/document/orgapp/compress-images
    var api = 'dd.biz.util.compressImage';
    (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params);
}

export { compressImage as default };
